//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { TelephoneInformationDisplayItem } from './TelephoneInformationDisplayItem';
import { NewsReaderProfileDisplayItem } from './NewsReaderProfileDisplayItem';

export class ParentProfileDisplayItem extends NewsReaderProfileDisplayItem {
    Address: string | null = null;
    EmailRemindersEnabled: boolean = false;
    IncludeInContactList: boolean = false;
    FamilyID: string | null = null;
    SMSRemindersEnabled: boolean = false;
    TimeZoneDisplayName: string | null = null;
    TimeZoneID: string | null = null;
    Title: string | null = null;
    TelephoneHome: TelephoneInformationDisplayItem | null = null;
    TelephoneMobile: TelephoneInformationDisplayItem | null = null;
    TelephoneWork: TelephoneInformationDisplayItem | null = null;
    AdultStudentID: string | null = null;

    constructor(initializer?: Partial<ParentProfileDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "ParentProfileDisplayItem";
}
